const getIfr = () => {
  const ifr = document.getElementById('iframe_360');
  return ifr ? (ifr.window || ifr.contentWindow) : window;
}
const app = {
  setHotspotStatus(val){
    getIfr().setHotspotStatus(val)
  },
  changeOutConfig(accessory, styleName){
    getIfr().changeOutConfig(accessory, styleName)
  },
    carDoorOneAnimation(){
      getIfr().changeOutConfig('changeDoor','backDoor1')
        getIfr().carDoorOneAnimation()
    },
    carDoorTowAnimation(){
        getIfr().changeOutConfig('changeDoor','backDoor2')
        getIfr().carDoorTowAnimation()
    }
}

export default app
